export default __webpack_public_path__ + "static/media/google.5f653033.svg";